import CONFIG from '../constants/config'

/**
 * 按当前系统返回 AI PC 版的稳定下载入口。
 * 稳定入口由 AIPC 发版服务指向最新安装包，Web 端不写死版本号。
 */
export function getAiDesktopDownloadUrl(isMac: boolean): string {
  return isMac
    ? CONFIG.AI_DESKTOP_DOWNLOAD_URL_MAC
    : CONFIG.AI_DESKTOP_DOWNLOAD_URL
}
